export function customScripts() {
  if (document.getElementById('site-wrap')) {
    document.getElementById('site-wrap').classList.add("loaded");
  }

  if (document.getElementById('dropdown-button-opt1')) {
    var dropdownButton = document.getElementById('dropdown-button-opt1');
    var dropdownMenu = document.getElementById('dropdown-menu-opt1');

    createDropdownMenu(dropdownButton, dropdownMenu);
  }
  
  if (document.getElementById('dropdown-button-opt2')) {
    var dropdownButton = document.getElementById('dropdown-button-opt2');
    var dropdownMenu = document.getElementById('dropdown-menu-opt2');

    createDropdownMenu(dropdownButton, dropdownMenu);
  }
  
  if (document.getElementById('dropdown-button-opt3')) {
    var dropdownButton = document.getElementById('dropdown-button-opt3');
    var dropdownMenu = document.getElementById('dropdown-menu-opt3');

    createDropdownMenu(dropdownButton, dropdownMenu);
  }

  if (document.getElementById('navbar')) {
      var navbar = document.getElementById('navbar');
      document.addEventListener('click', function (event) {
          if (
              !navbar.contains(event.target) &&
              !event.target.classList.contains('navbar__link')
          ) {
              Array.from(
                  document.getElementsByClassName('navbar__menu'),
              ).forEach(el => el.classList.remove('navbar__menu--show'));
          }
      });
  }

  if (document.getElementById('header')) {
    var header = document.getElementById('header');
    document.querySelector(".main-content").style.marginTop = header.clientHeight + 'px';
    window.addEventListener('resize', function(){
      document.querySelector(".main-content").style.marginTop = header.clientHeight + 'px';
    });



  }

}

function createDropdownMenu(dropdownButton, dropdownMenu){
  window.addEventListener('click', event => {
    event.stopPropagation();
    if (event.target !== 'dropdown-button')
      dropdownMenu.classList.remove('show');
  });

  dropdownButton.onclick = function (event) {
    event.stopPropagation();
    dropdownMenu.classList.toggle('show');
  };
}
